import React from "react";
import { Link, withRouter } from "react-router-dom";
import defaultThumb from "assets/img/defaults/default-thumbnail.jpg";
import Modal from "../../shared/Modal";

import Slider from "react-slick";
// Import css files
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { getDate } from "../../helpers/utilities";

const MapYUP = props => {
    var settings = {
        dots: false,
        infinite: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        adaptiveHeight: true,
        //fade: true
    };

    // function formatDate(date){
        
    //     const new_date = new Date(date);
    //     const month = new_date.getMonth();
    //     const day = new_date.getDate();
    //     const year = new_date.getFullYear();
    //     const dateNames = [
    //         "Jan",
    //         "Feb",
    //         "Mar",
    //         "Apr",
    //         "May",
    //         "Jun",
    //         "Jul",
    //         "Aug",
    //         "Sep",
    //         "Oct",
    //         "Nov",
    //         "Dec"
    //     ];

    //     const fullDate = dateNames[month] + " " + day + ", " + year;

    //     return fullDate
    // }

    
    let content = <div class="alert alert-info" role="alert">No available updates.</div>
    if (props.items !== undefined && props.items.length > 0) {
        content = props.items.map((item, index) => {
            if(item.update_type === 'YUP'){
                return (<div>
                            <center>
                            <img src={item.image} className="img-responsive" />
                            <h4>As of {getDate(item.update_date)}</h4>
                            </center>
                        </div>);
            }
        });

        return (<Slider {...settings}>{content}</Slider>)
    }
    else{
        return content;
    }
};

export default withRouter(MapYUP);
